import React from 'react';
import styled from 'react-emotion';
import { LinkElemnts } from './Footer/FooterLinks';
// import CategoryTree from '../CategoryPage/CategoryTree/CategoryTree';
import t from '@jetshop/intl';

import CategoryTree from './CategoryTree';

export const LinkList = styled('nav')`
  width: 100%;
  li,
  h2 {
    position: relative;
    width: 100%;
    display: block;
    background: #fff;
    margin: 0.4rem 0;
    margin-top: 0;
    padding: 0;
    line-height: 1.7rem;
    margin-bottom: 5px;
    padding-left: 1rem;

    a {
      color: inherit;
      text-decoration: none;

      &:hover {
        color: ${p => p.theme.colors.active};
        text-decoration: underline;
      }

      &.active {
        font-weight: bold;
      }
    }
  }
  .header {
    background: ${({ theme }) => theme.colors.leftaside.information};
    color: #fff;
    border-radius: 3px;
    padding: 0.2rem 0 0.2rem 1rem;
    font-weight: bold;
  }
`;

export const PageList = () => (
  <LinkList aria-label="Footer">
    <h2 className="header">{t('Information')}</h2>
    <LinkElemnts />
  </LinkList>
);

const LeftAside = ({ route, category, hideCategoryTree }) => (
  <>
    {!hideCategoryTree && <CategoryTree category={category} route={route} />}
    <PageList />
  </>
);

export default LeftAside;
